// import('import/js/slick.min.js');
// import('import/js/jquery.fancybox.min.js');

/* tslint:disable */
interface JQuery {
    slick(options?: any): any;
    fancybox(options?: any): any;
}
/* tslint:enable */

jQuery(function($) {
    let carouselConfig = {
        defaultEaseFn: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        prevArrow: '<button class="carousel__arrow carousel__arrow--left"><svg class="icon"><use xlink:href="' + gotoAndPlay.svgPath +  '#arrow-left"></use></svg></button>',
        nextArrow: '<button class="carousel__arrow carousel__arrow--right"><svg class="icon"><use xlink:href="' + gotoAndPlay.svgPath +  '#arrow-right"></use></svg></button>',
    };

    $('.carousel.carousel--multiple').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
                dots: false,
                infinite: false,
                autoplay: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                draggable: false,
                cssEase: carouselConfig.defaultEaseFn,
                useTransform: true,
                speed: 500,
                zIndex: 1,
                variablewidth: true,
                arrows: true,
                adaptiveHeight: true,
                mobileFirst: false,
                nextArrow: carouselConfig.nextArrow,
                prevArrow: carouselConfig.prevArrow,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            draggable: true,
                            speed: 500,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            draggable: true,
                            speed: 500,
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            draggable: true,
                            speed: 500,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });

        }
    });

    $('.carousel.carousel--app').each(function() {
        if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
                dots: true,
                infinite: false,
                autoplay: false,

                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: false,
                cssEase: carouselConfig.defaultEaseFn,
                useTransform: true,
                speed: 500,
                zIndex: 1,

                arrows: false,
                adaptiveHeight: false,
                mobileFirst: false,
            });
        }
    });

    $('.js-fancybox').each(function() {
        let el = $(this);

        $(this).fancybox({
            afterClose: function(instance, current) {
                el.css('display', 'inline');
            },
        });
    });
});
